import { SparkleIcon } from '@phosphor-icons/react';
import { T } from 'gt-react';
import { cn } from '@/lib/utils';

/**
 * "via AI assistant" marker. The actor stays the person; this says the change
 * came through the assistant on their instruction. Purple is confined to the
 * sparkle glyph, per DESIGN.md.
 */
export function NamiViaBadge({
  compact = false,
  className,
}: {
  compact?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border border-agent-border bg-agent-subtle px-1.5 py-px text-[0.65rem] leading-4 text-foreground',
        className,
      )}
    >
      <SparkleIcon
        weight="fill"
        className="size-3 text-purple-600 dark:text-purple-400"
        aria-hidden
      />
      {compact ? (
        <T context="compact badge on an activity entry the AI assistant performed for the user">
          assistant
        </T>
      ) : (
        <T context="badge on an activity entry the AI assistant performed for the user">
          via AI assistant
        </T>
      )}
    </span>
  );
}
